const JsonData = {
    "defaultFilePath": "https://dashboard.metazonia.com.br/assets/",
};

export default JsonData;